import React from "react";
import comingsoon from "../../../../../Assets/comingsoon.png";
import Back from "../../../../../Components/Back";

const CustomCard = ({ setCard }) => {
  return (
    <div className="py-4 px-8 bg-white rounded-lg shadow-md shadow-gray-400 relative">
      <Back className="absolute top-8" onClick={() => setCard("")} />
      <div className="flex justify-center">
        <img alt="coming soon" className="h-[99%] w-[60%]" src={comingsoon} />
      </div>
    </div>
  );
};

export default CustomCard;
